<template>
  <div style="">
    <el-tabs :tab-position="tabPosition" v-model="activeTabName" @tab-click="setActiveTabName(activeTabName)">
      <el-tab-pane v-for="tab in tabs" :label="tab.displayName" :name="tab.name" :key="tab.id">
        <div v-if="( tab.name === activeTabName)">
          <component :is="tab.component_name" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Process from './process'
import Clause from './clause'
export default {
  name: 'Setting',
  components: {
    Process,
    Clause
  },
  data() {
    return {
      tabPosition: 'left',
      activeTabName: '',
      tabs: [
        {
          name: 'clause',
          displayName: 'Clause',
          component_name: Clause
        },
        {
          name: 'process',
          displayName: 'Process',
          component_name: Process
        }
      ]
    }
  },
  created: function() {
    this.activeTabName = this.tabs[0].name
  },
  methods: {
    setActiveTabName(tabname) {
      this.activeTabName = tabname
    }
  }
}
</script>

<style scoped>

</style>
